module.exports = __webpack_public_path__ + "img/anxinkv.95fbdf5a.png";